module.exports = __webpack_public_path__ + "static/media/auto-small.1cde2e0b.webp";